import Api from "@/services/Api";

/**
 * Gjendja analitike: stock as Financa reports it, per magazine per product.
 * Data is written by the `financa:sync-stock` cron every 5 minutes.
 */
export default {
  async getStock(payload) {
    const response = await Api(true).post("stock/financa/get/all", payload);
    return response.data;
  },

  async getStockTotals(payload) {
    const response = await Api(true).post("stock/financa/get/all", { ...payload, totals_only: true });
    return response.data;
  },

  async getMovements(payload) {
    const response = await Api(true).post("stock/financa/movements", payload);
    return response.data;
  },

  async getMovementTotals(payload) {
    const response = await Api(true).post("stock/financa/movements", { ...payload, totals_only: true });
    return response.data;
  },

  async getProductHistory(payload) {
    const response = await Api(true).post("stock/financa/product/history", payload);
    return response.data;
  },

  async getProductHistoryCurrent(payload) {
    const response = await Api(true).post("stock/financa/product/history", {
      ...payload,
      include_movements: false,
    });
    return response.data;
  },

  async getProductHistoryMovements(payload) {
    const response = await Api(true).post("stock/financa/product/history", {
      ...payload,
      movements_only: true,
    });
    return response.data;
  },

  async getFilters() {
    const response = await Api(true).post("stock/financa/filters", {});
    return response.data;
  },

  async getStatus() {
    const response = await Api(true).post("stock/financa/status", {});
    return response.data;
  },

  async syncNow() {
    const response = await Api(true).post("stock/financa/sync-now", {});
    return response.data;
  },

  /** Admin (type_id 1 / superadmin): fill financa stock tables with fake data for UI testing. */
  async seedFake() {
    const response = await Api(true).post("stock/financa/dev/seed-fake", {});
    return response.data;
  },

  /** Admin (type_id 1 / superadmin): wipe fake financa stock before going live. */
  async clearFake() {
    const response = await Api(true).post("stock/financa/dev/clear-fake", {});
    return response.data;
  },

  /**
   * Resolve a spreadsheet of codes to guids. Nothing is saved; the guids are
   * only used to preselect the page filters. `type` is "product" or "warehouse".
   */
  async resolveImport(file, type) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("type", type);
    const response = await Api(true).post("stock/financa/import/resolve", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  async exportStock(payload) {
    const response = await Api(true).post("stock/financa/export", payload, { responseType: "blob" });
    return response;
  },

  async exportMovements(payload) {
    const response = await Api(true).post("stock/financa/export/movements", payload, { responseType: "blob" });
    return response;
  },

  async getDashboard(payload) {
    const response = await Api(true).post("stock/financa/dashboard", payload);
    return response.data;
  },

  async getCalendarMatrix(payload) {
    const response = await Api(true).post("stock/financa/calendar/matrix", payload);
    return response.data;
  },

  async getCalendarCell(payload) {
    const response = await Api(true).post("stock/financa/calendar/cell", payload);
    return response.data;
  },

  async exportCalendar(payload) {
    const response = await Api(true).post("stock/financa/calendar/export", payload, { responseType: "blob" });
    return response;
  },

  async markIntakeRead(syncId) {
    const response = await Api(true).post("stock/financa/mark-intake-read", { sync_id: syncId });
    return response.data;
  },

  /** Turn a blob response into a browser download, honouring Content-Disposition. */
  saveBlobDownload(response, fallbackName) {
    let filename = fallbackName;
    const disposition = response?.headers?.["content-disposition"] || "";
    const match = disposition.match(/filename="?([^";]+)"?/i);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
